<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-xs(:title="$t('sec1')" tag="h2")
        p.u-mb-mi.u-text-lg {{$t('sec1Desc')}}
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-xs(:title="$t('sec2')" tag="h2")
        p.u-mb-mi.u-text-lg {{$t('sec2Desc')}}
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}


  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec4')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec4Items')")
            h4 {{item.title}}
            p.u-mb-ts {{item.desc}}
            AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}


  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Interaction",
    "pageDesc":"Wireframing, prototyping and designing UI for websites, apps, design systems considering the ux strategy, ux writing and usability.",
    "mantra":"Seamless interaction |experience.",
    "sec1":"Website interaction design",
    "sec1Desc":"Using up - to - date techniques and following the latest user patterns to create websites that converts and supports business goals. ",
    "sec1Items":{
      "1":{
        "title":"Industry Based",
        "desc":"We start with a deep industry understanding to get familiar with trends, competitors and target persona pain points. "
      },
      "2":{
        "title":"User Centered",
        "desc":"Through a tailored user research process, we use different techniques from card sorting to user interviews to learn more on website users' needs and build a design that guides them to fulfill it."
      },
      "3":{
        "title":"Experience Driven",
        "desc":"Following the mental, behavioral, emotional and conceptual models we wireframe sites and imaging every possible user scenario to ensure an interactive experience."
      },
      "4":{
        "title":"Functional Design",
        "desc":"Turning wireframes into a prototype with regard to the brand guidelines and basic design principles in spacing to ensure legibility and contrast. "
      },
      "5":{
        "title":"Testing and Usability",
        "desc":"Gain high traffic and higher conversion rates with continuous iteration, A/B testing, and heat  map insights."
      }
    },
    "sec2":"Mobile interaction design",
    "sec2Desc":"Do more with Apps and humanize Your Business by stimulating real human interactions with a swipe, pinch, drag and drop. ",
    "sec2Items":{
      "1":{
        "title":"Friendly With Unlimited Features",
        "desc":"Translate all your business goals into App features with logical user scenarios and task flows. "
      },
      "2":{
        "title":"Open New Communication Channels",
        "desc":"Be one finger touch away from your customers and  communicate easier."
      }
    },

    "sec4":"Designing engaging experiences",
    "sec4Items":{
      "1":{
        "title":"App design",
        "desc":"Whatever the functionality you need, we design the user flows to contain it all in a smooth manner that moves the user from one step to easily.",
        "url":"/services/app-design"
      },
      "2":{
        "title":"Web design",
        "desc":"Custom made web designs that takes into account your brand elements and supports your ned users goals.",
        "url":"/services/web-design"
      },
      "3":{
        "title":"User interface",
        "desc":"Creating strategic UI based on the UX strategy and the tested prototypes to empower you with a functional design. We use color schemes, white spaces and grids to keep the design aesthetics and overall feeling.",
        "url":"/services/user-interface"
      },
      "4":{
        "title":"User experience",
        "desc":"Analyzing competitor, conducting research and fully understanding the final product audience to create an experience they would be familiar with.",
        "url":"/services/user-experience"
      },
      "5":{
        "title":"Usability",
        "desc":"Ensure the functionality of the website and applications produced. We run various tests with real users to detect usability obstacles and build better versions.",
        "url":"/services/usability"
      },
      "6":{
        "title":"Design systems",
        "desc":"Following a strategic approach, we create design systems that give your company the brandability needed to stand out.",
        "url":"/services/design-systems"
      },
      "7":{
        "title":"UX consulting",
        "desc":"Enhancing your interfaces and making it more accessible with strategic UX consulting that puts users at the center.",
        "url":"/services/user-experience-consulting"
      }
    },
    "cta":"Design your fun <br> interaction "
  },
  "ar": {
    "pageTitle":"التصميم التفاعلي",
    "pageDesc":"نصمم الإطارات الشبكية والنماذج الأولية والمواقع والتطبيقات وأنظمة التصميم من خلال الاعتماد على استراتيجية تجربة المستخدم والكتابة لتجربة المستخدم وقابلية الاستخدام.",
    "mantra":"نؤسس تجارب سلسلة |من خلال التصميم التفاعلي.",
    "sec1":"تصميم المواقع التفاعلية",
    "sec1Desc":"اعتمد على التقنيات الحديثة وأحدث أنماط المستخدم من أجل إنشاء مواقع ويب تعمل على دعم وتحقيق أهداف عملك التجاري.",
    "sec1Items":{
      "1":{
        "title":"تصميمات قائمة على الصناعة",
        "desc":"نبدأ أولًا بفهم عميق للصناعة من خلال التعرف على تراندات الصناعة وفهم المنافسين والمشكلات ونقاط الألم التي يعاني منها المستخدمين."
      },
      "2":{
        "title":"تصميمات محورها المستخدم",
        "desc":"من خلال عملية البحث التي تركز على المستخدم والتي تعتمد على تقنيات مختلفة فرز البطاقات (card sorting) إلى المقابلة مع المستخدمين الحقيقيين لمعرفة المزيد عن احتياجاتهم وبناء موقع يوفر هذه الاحتياجات."
      },
      "3":{
        "title":"التجربة تأتي أولًا",
        "desc":"بابتاع كل من النماذج العقلية والسلوكية والعاطفية والمفاهيمية، نقوم بتصميم الإطارات الشبكية من أجل تصور الموقع والسيناريوهات المحتملة لضمان تجربة تفاعلية."
      },
      "4":{
        "title":"تصميمات وظيفية",
        "desc":"تحويل الإطارات الشبكية إلى نموذج أولي مع الأخذ في الاعتبار إرشادات العلامة التجارية ومبادئ التصميم الأساسية في التباعد من أجل تحقيق الوضوح والتباين."
      },
      "5":{
        "title":"الاختبار وسهولة الاستخدام",
        "desc":"احصل على عدد زوار أعلى ومعدلات تحويل مرتفعة مع المزيد من المراجعات المستمرة واختبار التقسيم أ/ب ورؤي الخرائط الحرارية (heat  map)."
      }
    },
    "sec2":"التصميمات التفاعلية للجوال",
    "sec2Desc":"يمكنك تصميم التطبيقات مع الأخذ في الاعتبار إضفاء الطابع الإنساني على عملك من خلال تحفيز التفاعلات الإنسانية الحقيقية من خلال السحب والإفلات.",
    "sec2Items":{
      "1":{
        "title":"تصميمات سهلة بمميزات غير محدودة",
        "desc":"نعمل على ترجمة جميع أهداف عملك إلى مميزات داخل التطبيق مع سيناريوهات منطقية تتطابق مع المستخدم وتدفقات المهام."
      },
      "2":{
        "title":"فتح قنوات تواصل جديدة",
        "desc":"كن بالقرب من عملائك ووسع نشاطك واجعلهم يتواصلون معك بلمسة واحدة من أجل علاقات أقوي وأسهل."
      }
    },
    "sec4":"نصمم تجارب جذابة.",
    "sec4Items":{
      "1":{
        "title":"تصميم التطبيقات",
        "desc":"بغض النظر عن الوظيفية التي تحتاج إليها، نقوم بتصميم مسارات المستخدم التي تتناسب معه لاحتواء كل شيء بطريقة سلسة تنقل المستخدم من خطوة إلى أخرى بسهولة.",
        "url":"/services/app-design"
      },
      "2":{
        "title":"تصميم المواقع",
        "desc":"نقوم بتصميم المواقع المخصصة ونأخذ في الاعتبار عناصر علامتك التجارية وتدعم أهداف عملك وكذلك احتياجات المستخدمين.",
        "url":"/services/web-design"
      },
      "3":{
        "title":"واجهة المستخدم - UI",
        "desc":"نعمل على إنشاء واجهة مستخدم استراتيجية استنادًا إلى استراتيجية تجربة المستخدم والنماذج التي تم اختبارها؛ لتزويدك بتصميم وظيفي مناسب. نستخدم الألوان والمساحات البيضاء والشبكات للحفاظ على جماليات التصميم والانطباع العام.",
        "url":"/services/user-interface"
      },
      "4":{
        "title":"تجربة المستخدم - UX",
        "desc":"نحلل المنافسين ونجري البحوث ونفهم جمهور المنتج النهائي لخلق تجربة  مألوفة متناسبة مع احتياجاتهم.",
        "url":"/services/user-experience"
      },
      "5":{
        "title":"قابلية الاستخدام",
        "desc":"نعمل على ضمان وظائف الموقع والتطبيقات التي يتم إنشاؤها. نجري اختبارات مختلفة مع مستخدمين حقيقيين لاكتشاف عقبات قابلية الاستخدام التي تواجههم وثم نعمل على إنشاء إصدارات أفضل.",
        "url":"/services/usability"
      },
      "6":{
        "title":"أنظمة التصميم",
        "desc":"من خلال النهج الاستراتيجي الذي نتبعه، نقوم بإنشاء أنظمة تصميم تمنح شركتك التفرد اللازمة لتتميز بين منافسيها.",
        "url":"/services/design-systems"
      },
      "7":{
        "title":"استشارات تجربة المستخدم",
        "desc":"نحسن من واجه المستخدم الخاصة بك ونجعلها سهلة الاستخدام للجميع من خلال استشارات تجربة المستخدم التي نضعها والتي تتمحور حول سلوك المستخدمين.",
        "url":"/services/user-experience-consulting"
      }
    },
    "cta":"صمم تجربة ممتعة <br> لعملائك الآن. "
  }
}
</i18n>
